import {
  GetCitationUploadSignedUrlPayload,
  GetBulkCitationUploadSignedUrlsPayload,
  FileUploadStatus,
  GetProcessingCitationFilePayload,
  GetImportedCitationFilesPayload,
  DeleteImportedCitationAndFilePayload,
  DownloadCorruptionReportPayload,
  UntrackFilesByStatusPayload,
  UntrackFilesStatusPayload,
  GetFailedImportsPayload,
  SaveStudyNotePayload,
  StudyExportPayload,
  StudyEnterRecordPayload
} from "@/store/modules/study/study.types";
import axios from "axios";

export const studyApi = {
  getCitationUploadSignedUrl({ projectId, screeningStage, fileName }: GetCitationUploadSignedUrlPayload) {
    return axios.get(`projects/${projectId}/studies/screening/${screeningStage}/import/${fileName}`);
  },
  getBulkCitationUploadSignedUrls({ projectId, screeningStage, fileDetails }: GetBulkCitationUploadSignedUrlsPayload) {
    return axios.post(`projects/${projectId}/studies/screening/${screeningStage}/bulk-import`, fileDetails);
  },
  updateCitationFileUploadStatus(projectId: number, fileId: number, status: FileUploadStatus) {
    return axios.patch(`projects/${projectId}/studies/screening/imported-file/${fileId}/${status}`);
  },
  getProcessingCitationFiles({
    projectId, offset = 0, isSelf, limit = 5, sortOrder, sortColumn }: GetProcessingCitationFilePayload) {
    return axios.get(
      `projects/${projectId}/studies/screening/processing-file`, { params: { offset, isSelf, limit, sortOrder, sortColumn } });
  },
  getProcessingFilesCounts(projectId: number) {
    return axios.get(`projects/${projectId}/studies/screening/processing-file/count`);
  },
  getUserProcessingFileStatusCounts(projectId: number) {
    return axios.get(`projects/${projectId}/studies/screening/processing-file/user-count`);
  },
  untrackFileStatus({ projectId, fileIds }: UntrackFilesStatusPayload) {
    return axios.patch(`projects/${projectId}/studies/screening/processing-file/untrack-files`, { fileIds });
  },
  untrackFilesByStatus({ projectId, status }: UntrackFilesByStatusPayload) {
    return axios.patch(`projects/${projectId}/studies/screening/processing-file/untrack-files/${status}`);
  },
  getImportedCitationFiles({ projectId, page, perPage, search }: GetImportedCitationFilesPayload) {
    return axios.get(`projects/${projectId}/studies/screening/imported-citation-files?page=${page}&perPage=${perPage}&search=${search}`);
  },
  getFailedImports({ projectId, page, perPage, search }: GetFailedImportsPayload) {
    return axios.get(`projects/${projectId}/studies/screening/failed-imports?page=${page}&perPage=${perPage}&search=${search}`);
  },
  deleteImportedCitationAndFile({ projectId, fileId, userId }: DeleteImportedCitationAndFilePayload) {
    return axios.delete(`projects/${projectId}/studies/screening/delete-imported-citation-file/${fileId}/${userId}`);
  },
  downloadCorruptionReport({ projectId, fileId }: DownloadCorruptionReportPayload) {
    return axios.get(`projects/${projectId}/studies/screening/imported-file/${fileId}/corruption-report/download`);
  },
  getUserLatestFailedImport(projectId: number) {
    return axios.get(`projects/${projectId}/studies/screening/failed-import/latest`);
  },
  createStudyNote({ projectId, studyId, ...payload }: SaveStudyNotePayload) {
    return axios.post(`projects/${projectId}/studies/${studyId}/note`, payload);
  },
  updateStudyNote({ projectId, studyId, studyNoteId, ...payload }: SaveStudyNotePayload) {
    return axios.put(`projects/${projectId}/studies/${studyId}/note/${studyNoteId}`, payload);
  },
  getStudyNotes(projectId: number, studyId: number) {
    return axios.get(`projects/${projectId}/studies/${studyId}/note`);
  },
  exportCitations({ projectId, ...payload }: StudyExportPayload) {
    return axios.post(`projects/${projectId}/studies/export`, payload);
  },
  getAuthorsByProject(projectId: number) {
    return axios.get(`projects/${projectId}/studies/authors-by-project`);
  },
  getPublicationTypes(projectId: number) {
    return axios.get(`projects/${projectId}/studies/publication-types`);
  },
  enterRecord({ projectId, screeningType, ...payload }: StudyEnterRecordPayload) {
    return axios.post(`projects/${projectId}/studies/${screeningType}/enter-record/`, payload.newCitation);
  },
}